'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdViewComfortable = function MdViewComfortable(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm30 8.4h6.6v6.6h-6.6v-6.6z m0 23.2v-6.6h6.6v6.6h-6.6z m-8.4 0v-6.6h6.8v6.6h-6.8z m-8.2 0v-6.6h6.6v6.6h-6.6z m-8.4 0v-6.6h6.6v6.6h-6.6z m25-8.2v-6.8h6.6v6.8h-6.6z m-8.4-15h6.8v6.6h-6.8v-6.6z m-8.2 6.6v-6.6h6.6v6.6h-6.6z m8.2 8.4v-6.8h6.8v6.8h-6.8z m-8.2 0v-6.8h6.6v6.8h-6.6z m-8.4 0v-6.8h6.6v6.8h-6.6z m0-8.4v-6.6h6.6v6.6h-6.6z' })
        )
    );
};

exports.default = MdViewComfortable;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/view-comfortable.js
// module id = 2915
// module chunks = 0